module.exports = __webpack_public_path__ + "img/step3-4.2b6133fa.png";